import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/product", label: "Product" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="bg-[#F4F4F5] border-b-2 border-[#091526]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 h-32 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo-link">
          <div className="h-28 w-48 border-2 border-[#091526] bg-white flex items-center justify-center p-2">
            <img
              src="/images/logo.png"
              alt="Pile Glide Pro"
              className="max-h-full max-w-full object-contain"
            />
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-sm uppercase tracking-[0.2em] font-semibold transition-colors ${
                  isActive ? "text-[#1E5BB8]" : "text-[#091526] hover:text-[#1E5BB8]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="nav-cta-button"
          className="hidden md:inline-flex items-center bg-[#1E5BB8] text-white font-bold uppercase text-xs tracking-[0.2em] px-5 py-3 border-2 border-[#091526] hard-shadow hard-shadow-hover"
        >
          Request Quote
        </Link>

        <button
          className="md:hidden border-2 border-[#091526] p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-[#091526] bg-[#F4F4F5]" data-testid="nav-mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className="font-mono text-sm uppercase tracking-[0.2em] font-semibold"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-cta"
              className="inline-flex justify-center bg-[#1E5BB8] text-white font-bold uppercase text-xs tracking-[0.2em] px-5 py-3 border-2 border-[#091526]"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
